export default {
    dependencies: ['$element', 'templateservice', 'radio'],
    callable(ele, templateService, radio) {
        radio('favorites-toggle').subscribe(syncToggleButton);

        function syncToggleButton(isFavorited) {
            ele.innerHTML = templateService.render('favorites.togglebutton', {
                isFavorited,
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/favoritesToggleButton.js